import Api from "~/service/Api";

class TourExportedTourVideoRepository {
  fetchOne(locale, tourId) {
    return Api.get(`/${locale}/tour/exported-tour-videos/${tourId}`);
  }

  update(locale, tourId, data) {
    return Api.put(`/${locale}/exported-tour-videos/${tourId}/youtube`, data);
  }

  updateSettings(locale, tourId, data) {
    return Api.put(`/${locale}/exported-tour-videos/${tourId}/youtube-settings`, data);
  }
}

export default TourExportedTourVideoRepository;
